import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma de recherche d'une identité pour l'écran préférences
 * (`GET /NotificationPreferences/party/{partyId}`). Factory mémoïsée sur
 * la langue courante (règle projet).
 */
export const createPartyLookupSchema = () =>
  z.object({
    partyId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
  });

export type PartyLookupFormValues = z.infer<
  ReturnType<typeof createPartyLookupSchema>
>;
